// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"f3124105","498":"f3265919","703":"5e9f1620"}[chunkId] + ".chunk.js";
};